import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';




class Subscription extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	async componentDidMount() {

	}

	async componentDidUpdate() {

	}


	render() {
		const { userTheme } = this.props;
		let poster = require('../../../src/static/Subscription_Metrics.png');
		return (
			<div style={{marginLeft:20}}>
			<p style={{color:userTheme === "dark"? "white" : "black"}}>
			Craffview provides subscription tracking that monitors daily sales result in term of region, cost, and subscription plan that help decision maker optimize to create pricing strategy.			
			</p>
			<img alt="" src={poster} style={{width: '50%'}}></img>
			</div>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	inspectionTime: state.analytics.inspectionTime,
	userTheme: state.user.userTheme,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
